import { render, staticRenderFns } from "./LiveRecordingLibraryBadge.vue?vue&type=template&id=9d4b0d6e&scoped=true&"
import script from "./LiveRecordingLibraryBadge.vue?vue&type=script&lang=js&"
export * from "./LiveRecordingLibraryBadge.vue?vue&type=script&lang=js&"
import style0 from "./LiveRecordingLibraryBadge.vue?vue&type=style&index=0&id=9d4b0d6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4b0d6e",
  null
  
)

export default component.exports